import Section from '../page/section'
import Navigation from '../components/navigation'
let instance;

export default class Controller {
  constructor(pagesInfo) {
    if (instance) return instance;
    instance = this;
    this.sections = this._createSection(pagesInfo);
    this.pages = this._createPages(pagesInfo);
    this.pageInfo = {
      currentSection:'',
      nextSection:'',
      currentPage: '',
      nextPage: '',
      pageLength: Object.keys(this.pages).length,
      pageIndex:-1
    };
    this.size = {
      width : 1920,
      height : 1080
    };
    this.navi = new Navigation({
      ele:'nav',
      subOpenType:'selected'
    })
    window.addEventListener("resize", this._resize.bind(this))
    this._resize();

  }

  _createSection(pagesInfo){
    let i, sections = {};
    for (i in pagesInfo) {
      let section = {};
      section.key = pagesInfo[i].key;
      section.class =  new Section(pagesInfo[i]);
      section.id = i;
      sections[pagesInfo[i].key] = section;
    }
    return sections;
  }

  _createPages(pagesInfo) {
    let i, j, index=0, pages = {};
    for (i in pagesInfo) {
      for (j in pagesInfo[i].sub) {
        let page = {};
        page.key = pagesInfo[i].sub[j].key;
        page.class = new pagesInfo[i].sub[j].className(pagesInfo[i].sub[j]);
        page.index = index;
        page.id = j;
        page.sectionId = i;
        page.sectionKey = pagesInfo[i].key;

        pagesInfo[i].sub[j].ele.addEventListener('pageEvent', this._pageEvent.bind(this));

        pages[pagesInfo[i].sub[j].key] = page;
        index++;
      }
    }
    return pages;
  }

  init() {
    $(window).on( 'hashchange', e => this._changeURL() ).trigger('hashchange');

    document.documentElement.addEventListener('onwheel' in document ? 'wheel' : 'mousewheel', (() => {
      var e, deltax, deltay, lastmovedtime = 0;
      return (e) => {
        if (!this.leady) return;
        deltax = e.deltaX !== undefined ? e.deltaX : e.wheelDeltaX || 0,
          deltay = e.deltaY !== undefined ? e.deltaY : e.wheelDeltaY !== undefined ? e.wheelDeltaY : e.detail || e.wheelDelta * -1;

        if (Math.abs(deltay) > 2 && new Date().getTime() - lastmovedtime > 100) {

          let direction = deltay > 0 ? 'next' : 'prev';
          this._wheelNavigator(direction)
          lastmovedtime = new Date().getTime();

        }
       // e.preventDefault();
      };
    })(), false);
   // this._changePage(this.pageInfo.keyArr[0]);
  }
  _changeURL(){
    const hash = location.hash.replace('#', '');
    if(hash == '')location.hash =`#${Object.keys(this.pages)[0]}`

    if(this.pageInfo.currentPage != hash) this._changePage(hash);
  }
  _wheelNavigator(direction) {
    let currentNum = this.pageInfo.pageIndex;
    if (direction === 'next') {
      if ((this.pageInfo.pageLength - 1) <= currentNum) return;
      currentNum++;
    } else {
      if (0 >= currentNum) return;
      currentNum--;
    }
    location.hash = `#${Object.keys(this.pages)[currentNum]}`
  }

  _changePage(key) {
    try{
      this.leady = false;
      let sectionKey = this.pages[key].sectionKey;
      let index = this.pages[key].index;
      let dx = 1;
      let isMovie = true;
      this.pageInfo.nextPage = key;

      if (this.pageInfo.currentPage === '') {
        this.pages[key].class.show();
        this.sections[sectionKey].class.show();
        isMovie = false;
      } else {
        if(this.pageInfo.pageIndex > index) dx *= -1;

        if(this.pageInfo.currentSection != sectionKey){
          this.sections[this.pageInfo.currentSection].class.hide(this.size, -dx/2);
          this.sections[sectionKey].class.show(this.size, dx);
          this.pages[this.pageInfo.currentPage].class.hide(this.size, 0, true);
          this.pages[key].class.show();
          isMovie = false;
        }else{
          this.pages[this.pageInfo.currentPage].class.hide(this.size, -dx/2);
          this.pages[key].class.show(this.size, dx, false);

        }

      }
      if(sectionKey == 'legend'){
        this.sections[sectionKey].class.move(this.pages[key].id, isMovie);
      }
      this.pageInfo.currentSection = sectionKey;
      this.pageInfo.currentPage = this.pageInfo.nextPage;
      this.pageInfo.nextPage = '';
      this.pageInfo.pageIndex = this.pages[key].index;

      this.navi.select =`menu${Number(this.pages[key].sectionId) + 1}-${Number(this.pages[key].id) + 1}`;

      //console.log(key)
      if(key == 'reservation1'){
        window.loadJsFile('https://i91.icast-ad.com/track?ccd=4291&mcd=01040601&pcd=10948');
      }
    }catch (e) {
     // console.log(e)
      location.hash =`#${Object.keys(this.pages)[0]}`
    }

  }


  _changePageComplete() {
    this.leady = true;

  }


  _pageEvent(e) {
    switch (e.detail.action) {
      case 'showComplete': {
        this._changePageComplete(e.detail.key)
        break;
      }
      case 'showLayer': {
        this.leady = false;
        break;
      }
      case 'hideLayer': {
        this.leady = true;
        break;
      }
    }
  }

  _resize(){
    this.size.width = window.innerWidth;
    this.size.height = window.innerHeight;
  }
}





// WEBPACK FOOTER //
// ./src/js/controller/controller.js